var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { fetchApiData, customElement, PIC } from '../Internals';
let PICTableViewer = class PICTableViewer extends LitElement {
    constructor() {
        super();
        this.options = {};
        this.postURL = '/test/tableviewer/tableviewer';
        this.postBody = {};
        this.dbTabelDefs = { dbTables: { DB: [] } };
        this.selectedFindWhatValue = '';
        this.selectedDatabaseValue = '';
        this.selectedTableValue = '';
        this.selectedIndexValue = '';
        this.selectedReadBytesValue = '';
        this.clauseFieldValue = '';
        this.isFirst = true;
        this.dataIsReady = false;
        this.responseData = {};
    }
    resizableGrid(table) {
        var row = table.getElementsByTagName('tr')[0];
        var cols = row ? row.children : undefined;
        if (!cols)
            return;
        table.style.overflow = 'hidden';
        var tableHeight = table.offsetHeight;
        for (var i = 0; i < cols.length; i++) {
            var div = createDiv(tableHeight);
            cols[i].appendChild(div);
            cols[i].style.position = 'relative';
            setListeners(div);
        }
        function setListeners(div) {
            var pageX;
            var curCol;
            var nxtCol;
            var curColWidth;
            var nxtColWidth;
            div.addEventListener('mousedown', function (e) {
                var _a;
                curCol = (_a = e.target) === null || _a === void 0 ? void 0 : _a.parentElement;
                nxtCol = curCol === null || curCol === void 0 ? void 0 : curCol.nextElementSibling;
                pageX = e.pageX;
                var padding = paddingDiff(curCol);
                if (curCol)
                    curColWidth = curCol.offsetWidth - padding;
                if (nxtCol)
                    nxtColWidth = nxtCol.offsetWidth - padding;
            });
            div.addEventListener('mouseover', function (e) {
                e.target.style.borderRight = '2px solid #0000ff';
            });
            div.addEventListener('mouseout', function (e) {
                e.target.style.borderRight = '';
            });
            document.addEventListener('mousemove', function (e) {
                if (curCol && pageX) {
                    var diffX = e.pageX - pageX;
                    if (nxtCol && nxtColWidth) {
                        nxtCol.style.width = (nxtColWidth - diffX) + 'px';
                    }
                    if (curColWidth) {
                        curCol.style.width = (curColWidth + diffX) + 'px';
                    }
                }
            });
            document.addEventListener('mouseup', function (e) {
                curCol = undefined;
                nxtCol = undefined;
                pageX = undefined;
                nxtColWidth = undefined;
                curColWidth = undefined;
            });
        }
        function createDiv(height) {
            var div = document.createElement('div');
            div.style.top = '0';
            div.style.right = '0';
            div.style.width = '5px';
            div.style.position = 'absolute';
            div.style.cursor = 'col-resize';
            div.style.userSelect = 'none';
            div.style.height = height + 'px';
            return div;
        }
        function paddingDiff(col) {
            if (getStyleVal(col, 'box-sizing') == 'border-box') {
                return 0;
            }
            var padLeft = getStyleVal(col, 'padding-left');
            var padRight = getStyleVal(col, 'padding-right');
            return (parseInt(padLeft) + parseInt(padRight));
        }
        function getStyleVal(elm, css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css));
        }
    }
    getDBTabeles() {
        this.options = {
            //   sessionId: PIC.getInstance.sessionCode,
            systemId: PIC.getInstance.systemId,
            postBody: { mode: 'getDBTabels' },
        };
        fetchApiData(this.postURL, this.options)
            .then((responseData) => {
            this.dbTabelDefs = responseData;
            if (this.dbTabelDefs)
                this.dataIsReady = true;
            else
                this.dataIsReady = false;
            this.requestUpdate();
        })
            .catch((err) => console.log('nothing works and this makes me a sad robot -_- : ' + err));
    }
    getDataFromAPI() {
        let postfields = {};
        let selectList = this.shadowRoot.querySelectorAll('select');
        selectList.forEach((elm) => {
            postfields[elm.id] = elm.value;
        });
        let clauseField = this.shadowRoot.querySelector('#clauseField');
        postfields['clauseField'] = clauseField.submitValue;
        this.postBody = { mode: 'getData', postfields };
        this.options = {
            //   sessionId: PIC.getInstance.sessionCode,
            systemId: PIC.getInstance.systemId,
            postBody: this.postBody,
        };
        fetchApiData(this.postURL, this.options)
            .then((responseData) => {
            var _a;
            this.responseData = responseData;
            this.requestUpdate();
            let resultTable = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#resultTable');
            this.resizableGrid(resultTable);
        })
            .catch((err) => console.log('nothing works and this makes me a sad robot -_- : ' + err));
    }
    connectedCallback() {
        super.connectedCallback();
        this.getDBTabeles();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    performUpdate() {
        super.performUpdate();
    }
    renderSelectOption(iValue, iTxt) {
        return html `<option value=${iValue}>${iTxt}</option>`;
    }
    getSelectedOptionsValue(e) {
        var _a, _b;
        let selOpt = (_a = e.target) === null || _a === void 0 ? void 0 : _a.selectedOptions;
        return (_b = selOpt[0]) === null || _b === void 0 ? void 0 : _b.value;
    }
    handleSelectValueUpdate(e, valueRef) {
        switch (valueRef) {
            case 'findWhat':
                this.selectedFindWhatValue = this.getSelectedOptionsValue(e);
                break;
            case 'database':
                this.selectedDatabaseValue = this.getSelectedOptionsValue(e);
                break;
            case 'table':
                this.selectedTableValue = this.getSelectedOptionsValue(e);
                break;
            case 'index':
                this.selectedIndexValue = this.getSelectedOptionsValue(e);
                break;
            case 'clauseField':
                this.clauseFieldValue = this.getSelectedOptionsValue(e);
                break;
            case 'readBytes':
                this.selectedReadBytesValue = this.getSelectedOptionsValue(e);
                break;
            default:
                break;
        }
        this.requestUpdate();
    }
    getSelectOptions(iCase) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        switch (iCase) {
            case 'database':
                if (this.isFirst && this.dataIsReady) {
                    this.selectedDatabaseValue = (_c = (_b = (_a = this.dbTabelDefs.dbTables) === null || _a === void 0 ? void 0 : _a.DB[0]) === null || _b === void 0 ? void 0 : _b.dataBaseName) !== null && _c !== void 0 ? _c : '';
                    this.selectedTableValue = (_g = (_f = (_e = (_d = this.dbTabelDefs.dbTables) === null || _d === void 0 ? void 0 : _d.DB[0]) === null || _e === void 0 ? void 0 : _e.tableType[0]) === null || _f === void 0 ? void 0 : _f.tableName) !== null && _g !== void 0 ? _g : '';
                    this.selectedIndexValue = (_m = (_l = (_k = (_j = (_h = this.dbTabelDefs.dbTables) === null || _h === void 0 ? void 0 : _h.DB[0]) === null || _j === void 0 ? void 0 : _j.tableType[0]) === null || _k === void 0 ? void 0 : _k.TableIndex[0]) === null || _l === void 0 ? void 0 : _l.indexName) !== null && _m !== void 0 ? _m : '';
                    this.isFirst = false;
                    this.dataIsReady = false;
                }
                return (_p = (_o = this.dbTabelDefs.dbTables) === null || _o === void 0 ? void 0 : _o.DB) === null || _p === void 0 ? void 0 : _p.map((db) => this.renderSelectOption(db.dataBaseName, db.dataBaseName));
            case 'table':
                return (_q = this.dbTabelDefs.dbTables.DB.find(x => x.dataBaseName === this.selectedDatabaseValue)) === null || _q === void 0 ? void 0 : _q.tableType.map(tt => this.renderSelectOption(tt.tableName, tt.tableName));
            case 'index':
                return (_s = (_r = this.dbTabelDefs.dbTables.DB.find(x => x.dataBaseName === this.selectedDatabaseValue)) === null || _r === void 0 ? void 0 : _r.tableType.find(tt => tt.tableName === this.selectedTableValue)) === null || _s === void 0 ? void 0 : _s.TableIndex.map(ti => this.renderSelectOption(ti.indexName, ti.indexName));
            default:
                break;
        }
    }
    getResultTableHeaders(hdrArr) {
        return html `<tr>${hdrArr === null || hdrArr === void 0 ? void 0 : hdrArr.map(hdr => html `<th>${hdr}</th>`)}</tr>`;
    }
    getResultTableRows(objDataArr) {
        return html `${objDataArr === null || objDataArr === void 0 ? void 0 : objDataArr.map(obj => { var _a; return html `<tr>${(_a = Object.values(obj)) === null || _a === void 0 ? void 0 : _a.map(cell => html `<td>${cell}</td>`)}</tr>`; })}`;
    }
    getResultTable() {
        var _a;
        let dataArr = (_a = this.responseData) === null || _a === void 0 ? void 0 : _a.records;
        let hdrArr = [];
        if (dataArr && dataArr[0])
            hdrArr = Object.keys(dataArr[0]);
        return html `
    <table id='resultTable'>
      <thead>${this.getResultTableHeaders(hdrArr)}</thead>
      <tbody>${this.getResultTableRows(dataArr)}</tbody>
    </table>
    `;
    }
    keyDownWrapper(e) {
        e.stopImmediatePropagation();
        if (e.key == 'Enter')
            this.getDataFromAPI();
    }
    render() {
        return html `
      <div class="searchFields">
        <div class="selectContainer">
          <label for="findWhat">Find What</label>
          <select
            id="findWhat"
            @change=${(e) => this.handleSelectValueUpdate(e, 'findWhat')}>
            <option value="For Each">For Each</option>
            <option value="Find First">Find First</option>
            <option value="Find Last">Find Last</option>
          </select>
        </div>
        <div class="selectContainer">
          <label for="database">DataBase</label>
          <select
            id="database"
            @change=${(e) => this.handleSelectValueUpdate(e, 'database')}>
            ${this.getSelectOptions('database')}
          </select>
        </div>
        <div class="selectContainer">
          <label for="table">Table</label>
          <select
            id="table"
            @change=${(e) => this.handleSelectValueUpdate(e, 'table')}>
            ${this.getSelectOptions('table')}
          </select>
        </div>
        <div class="selectContainer">
          <label for="index">Index</label>
          <select
            id="index"
            @change=${(e) => this.handleSelectValueUpdate(e, 'index')}>
            ${this.getSelectOptions('index')}
          </select>
        </div>
        <pic-text
          id="clauseField"
          label="Insert query"
          width="40"
          @keydown = ${this.keyDownWrapper}
          >
        </pic-text>
        <div class="selectContainer">
          <label for="readBytes">Read Bytes</label>
          <select
            id="readBytes"
            @change=${(e) => this.handleSelectValueUpdate(e, 'readBytes')}>
            <option value="32000">32k</option>
            <option value="64000">64k</option>
            <option value="128000">128k</option>
            <option value="256000">256k</option>
            <option value="512000">512k</option>
            <option value="1000000">1M</option>
            <option value="2000000">2M</option>
            <option value="5000000">3M</option>
          </select>
        </div>
        <button @click=${this.getDataFromAPI}>Send</button>
      </div>
      <div class="resultTable">
        ${this.getResultTable()}
      </div>
    `;
    }
};
PICTableViewer.styles = css `
    .selectContainer {
      display: flex;
      flex-direction: column;
    }
    .searchFields {
      display: flex;
      flex-direction: row;
    }
    .selectContainer select {
      height: 1.35rem;
      margin: 0.1rem;
      box-sizing: border-box;
      font-family: monospace;
      padding: 1px 2px;
    }
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
      overflow: hidden;
    }
    th {
      width: fit-content;
    }
    table {
      table-layout: fixed;
      width: 100%;
    }
    .resultTable {
      width: 100%;
    }
  `;
PICTableViewer = __decorate([
    customElement('pic-tableviewer')
], PICTableViewer);
export { PICTableViewer };
//# sourceMappingURL=PICTableViewer.js.map